<template>
  <div class="login-box">
    <div class="login-main-box">
      <div>
        <div style="width: 120px; height: 120px">
          <img src="../../../assets/images/loginIMG.png"
               style="border-radius: 50%"
               alt />
        </div>
      </div>

      <van-row class="login-bottom">
        <van-col span="24">
          <van-button :loading="loading"
                      block
                      icon="wechat"
                      type="primary"
                      size="large"
                      plain
                      round
                      @click="onSubmit">
            确定</van-button>
          <van-button style="margin-top: 20px"
                      :loading="loading"
                      type="default"
                      size="small"
                      @click="onTestSubmit">使用openId账号登录</van-button>
        </van-col>
      </van-row>
      <van-dialog v-model="IsShow"
                  showCancelButton
                  confirmButtonText="确定"
                  cancelButtonText="取消"
                  confirm-button-color="#ee0a24"
                  @confirm="confirm()">
        <div class="passWordField">
          <van-field label-width="20vw"
                     v-model="password"
                     placeholder="请输入密码"
                     clearable
                     label="密码"
                     :value="password">
          </van-field>
        </div>
      </van-dialog>
      <van-dialog v-model="IsLoginShow"
                  showCancelButton
                  confirmButtonText="确定"
                  cancelButtonText="取消"
                  confirm-button-color="#ee0a24"
                  @confirm="confirmButton(password1)">
        <div class="passWordField">
          <van-field label-width="20vw"
                     v-model="password1"
                     placeholder="请输入密码"
                     clearable
                     label="密码"
                     :value="password1">
          </van-field>
        </div>
      </van-dialog>
    </div>
  </div>
</template>
<script>
import {
  Row,
  Col,
  Icon,
  Cell,
  CellGroup,
  Field,
  Button,
  Notify,
  Dialog,
  Toast,
} from "vant";
import { mapGetters, mapActions } from "vuex";
import service from "../../api/redirect/index";
export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Dialog.Component.name]: Dialog.Component,
    [Toast.name]: Toast,
    [Button.name]: Button,
    [Notify.name]: Notify,
  },
  data () {
    return {
      password: "", //测试
      password1: "", //测试
      IsShow: false,
      IsLoginShow: false,
      phoneNumber: "",
      loading: false,
      IsTest: false,
      urlParmams: {},
      shareUrl: "",
    };
  },
  computed: {
    ...mapGetters(["userInfo", "bankCardStatus", "agentShow"]),
  },
  methods: {
    ...mapActions(["wxLogin", "statusOut", "saveBankStatus", "buyAgentStatus"]),
    onSubmit () {
      //
      service.isDebugger().then((res) => {
        // false直接访问 true密码验证
        if (res.data == true) {
          this.IsLoginShow = true;
        } else {
          let redirectUrl = this.$route.query.redirect || "/";
          console.log(
            "https://" + window.location.host + "/redirect",
            redirectUrl,
            98
          );

          var redirect = "https://" + window.location.host + "/redirect";
          var redirect_uri = encodeURIComponent(redirect);
          let getShareUrl = JSON.parse(localStorage.getItem("shareUrl"));
          console.log(getShareUrl, "getShareUrl");
          // debugger
          if (
            getShareUrl.isShared !== null &&
            getShareUrl.isShared !== undefined &&
            getShareUrl.isShared !== ""
          ) {
            location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${webconfig.appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=${redirectUrl}?goodsId=${getShareUrl.goodsId}?shareUserId=${getShareUrl.shareUserId}?SharedType=${getShareUrl.SharedType}?isShared=true#wechat_redirect`;
            localStorage.removeItem("shareUrl");
          } else {
            location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${webconfig.appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=${redirectUrl}#wechat_redirect`;
            localStorage.removeItem("shareUrl");
          }
          // this.qrCode = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${webconfig.appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=login?goodsId=${this.$route.query.code}?shareUserId=${this.userInfo.userId}?SharedType=1?isShared=true#wechat_redirect`

          this.IsLoginShow = false;
        }
      });
    },
    // need password login
    confirmButton (password1) {
      // this.IsLoginShow = true;
      if (password1 == "1030win") {
        let redirectUrl = this.$route.query.redirect || "/";
        console.log(
          "https://" + window.location.host + "/redirect",
          redirectUrl,
          98
        );

        // 需求 判断公司关闭的情况下 内部工作人员依旧可以通过密码进入 
        var redirect = "https://" + window.location.host + "/redirect";
        // "https://testygw.m.taohuasanbao.com/redirect"
        var redirect_uri = encodeURIComponent(redirect);
        let getShareUrl = JSON.parse(localStorage.getItem("shareUrl"));
        console.log(getShareUrl, "getShareUrl");

        // debugger
        if (
          getShareUrl.isShared !== null &&
          getShareUrl.isShared !== undefined &&
          getShareUrl.isShared !== ""
        ) {
          location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${webconfig.appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=${redirectUrl}?goodsId=${getShareUrl.goodsId}?shareUserId=${getShareUrl.shareUserId}?SharedType=${getShareUrl.SharedType}?isShared=true#wechat_redirect`;
          localStorage.removeItem("shareUrl");
        } else {
          location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${webconfig.appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=${redirectUrl}#wechat_redirect`;
          localStorage.removeItem("shareUrl");
        }

      } else {
        Toast("请输入正确的密码");
        this.IsLoginShow = true;
      }
    },
    // 测试
    // lhy 修改（此处为测试环境的登录）
    confirm (password) {
         if (this.password.trim() !== "") {
        // openid测试登录
        console.log(this.password, 'this.password')
        service
          .wxLoginTest(this.password, null, null, null, null)
          .then((res) => {
            if (res.statusCode == 200) {
              this.wxLogin(res.data).then(() => {
                // 代买状态
                // -----------原有代码---------------------
                console.log(this.agentShow, 174);
                this.buyAgentStatus({ show: false });
                this.$router.replace({
                  path: '/page',
                });
                // -------------------------------
              });
            } else {
              console.log(this.password, 111)
              this.password = ''
            }
          }).catch(err => {
            this.password = ''
          });
      } else {
        Toast("请输入正确的密码");
        this.IsShow = false;
      }
    },
    // lhy 截取参数函数
    getUrlParams (url) {
      let urlStr = url.split("?")[1];
      let obj = {};
      let paramsArr = urlStr.split("&");
      for (let i = 0, len = paramsArr.length; i < len; i++) {
        let arr = paramsArr[i].split("=");
        obj[arr[0]] = arr[1];
      }
      return obj;
    },

    //lhy 扫码记录接口 scanRecord
    postRecord (data) {
      // debugger
      console.log(data);
      service.scanRecord(data).then((res) => {
        if (res.data == true) {
          // 跳转用户绑定页面
          this.$router.push({
            name: "bind",
            query: { shareCode: res.shareCode },
          });
        } else {
          //跳转商品详情页
          this.$router.push({
            name: "goods",
            query: { code: this.urlParmams.goodsId, type: "1" },
          });
        }
      });
    },
    onTestSubmit () {
      this.IsShow = true;
    },
    onDisabled () {
      Toast('网站正在维护中')
    },
  },
  mounted () {
    // 根据url 不同 判断是正常登录还是分享登录
    this.shareUrl = window.location.href;
    console.log(this.shareUrl, " this.shareUrl");
    if (this.shareUrl.indexOf("?") > -1) {
      let urlParmams = this.getUrlParams(this.shareUrl);
      console.log(urlParmams, "urlParmams");
      localStorage.setItem("shareUrl", JSON.stringify(urlParmams));
    } else {
      let urlParmams = {};
      localStorage.setItem("shareUrl", JSON.stringify(urlParmams));
    }

    let obj = {
      color:
        this.bankCardStatus !== null && this.bankCardStatus.color
          ? this.bankCardStatus.color
          : 0,
    };
    // this.statusOut();
    console.log(webconfig.isDebugger, 159);
    service.isDebugger().then((res) => {
      // false直接访问 true密码验证
      if (res.data == true) {
        this.IsTest = true;
      }
    });
    this.saveBankStatus(obj);
  },
};
</script>

<style lang="less">
.login {
  &-box {
    position: fixed;
    width: 100%;
    bottom: 70px;

    img {
      width: 100%;
      height: 100%;
    }

    .buttonDisabled {
  /* 鼠标光标变成禁止样式 */
  cursor: not-allowed !important;
}

/* van‑button内部元素覆盖 */
.buttonDisabled.van-button--plain {
  color: #07c160!important;
  border-color: #07c160 !important;
  background-color: #fff !important;
  opacity: .5;
}

/* 图标也置灰 */
.buttonDisabled .van-icon {
  color: #78dda9 !important;
}
  }

  &-close {
    font-size: 2em;
    color: #666;
  }

  &-close-box {
    text-align: right;
  }

  &-title {
    margin-top: 5%;
    font-size: 6.2vw;
    text-align: center;
  }

  &-main-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  &-main {
    margin: 8% 0;
  }

  &-group {
    margin-bottom: 15px;
  }

  &-bottom {
    height: 100px;
    width: 80vw;
    margin-top: 25vw;
  }

  &-links {
    padding: 15px 0;
    font-size: 12px;
    text-align: center;
    background-color: #fff;

    .van-icon {
      display: block;
      font-size: 24px;
    }
  }
}
</style>
